export default {"src":"/_next/static/media/boksen.07d97ab5.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};